/* eslint-disable */
import client from '@/http/client';

const BASE_URL = '/users';

class ProfileService {
  async get() {
    return client.get(`${BASE_URL}/me/`);
  }
}

export default new ProfileService();
